"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addRecentlyViewed = exports.getRecentlyViewed = exports.deleteSavedProperties = exports.addSavedProperties = exports.getSavedPropertyIds = exports.getSavedProperties = void 0;
var effects_1 = require("redux-saga/effects");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var itemToSavePropertyRequest_1 = require("@/transformers/itemToSavePropertyRequest");
var StorageApi_1 = require("@/api/browser/StorageApi");
var SavePropertiesApiSaga_1 = require("@/pages/saveproperties/sagas/api/SavePropertiesApiSaga");
var savedPropertyCompactsToSavedResultItems_1 = require("@/pages/saveproperties/transformer/savedPropertyCompactsToSavedResultItems");
var SavePropertyRemoteAction_1 = require("@/pages/common/actions/SavePropertyRemoteAction");
var sortByCreatedDate_1 = require("@/pages/saveproperties/transformer/sortByCreatedDate");
var sortByOnMarket_1 = require("@/pages/saveproperties/transformer/sortByOnMarket");
var getSavedPropertyIdsRemote = function (state) { return state.savePropertyRemote.savePropertyIdsRemote; };
var getIsSavedPropertyIdsRemoteChanged = function (state) { return state.savePropertyRemote.isSavePropertyIdsRemoteChanged; };
var resultItemToSavedResultItem = function (properties) {
    var currentCurrencyId, todayStr, savedItems;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentCurrency)];
            case 1:
                currentCurrencyId = _a.sent();
                todayStr = (new Date()).toISOString();
                savedItems = properties.map(function (it) { return (__assign(__assign({}, it), { userPropertyId: null, available: true, currencyId: currentCurrencyId, createdDate: todayStr, images: it.images.slice(0, 2) })); });
                return [2 /*return*/, savedItems];
        }
    });
};
var savedResultItemToSavePropertiesSaveSet = function (savedItem) { return savedItem.map(itemToSavePropertyRequest_1.itemToSavePropertyRequest); };
var savedResultItemToRecentlyViewSaveSet = function (savedItem) { return savedItem.map(itemToSavePropertyRequest_1.itemToRecentlytViewedPropertyRequest); };
// Private
var getSavedPropertiesLocal = function (page, pageSize) {
    var existingProperties, savedProperties;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (page < 1)
                    return [2 /*return*/, {
                            properties: [],
                            totalPage: 0,
                        }];
                return [4 /*yield*/, effects_1.call(StorageApi_1.readSavedPropertyFromLocalStorage)];
            case 1:
                existingProperties = _a.sent();
                savedProperties = existingProperties.slice((page - 1) * pageSize, (page - 1) * pageSize + pageSize).map(function (it) { return (__assign(__assign({}, it), { isSaved: true })); });
                return [2 /*return*/, {
                        properties: savedProperties,
                        totalPage: Math.ceil(existingProperties.length / pageSize)
                    }];
        }
    });
};
var getSavedPropertyByIdsLocal = function () {
    var existingProperties, savedPropertyIds;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(StorageApi_1.readSavedPropertyFromLocalStorage)];
            case 1:
                existingProperties = _a.sent();
                savedPropertyIds = existingProperties.map(function (it) { return Number(it.referenceId); });
                return [2 /*return*/, savedPropertyIds];
        }
    });
};
var getSavedPropertyByIdsRemote = function () {
    var isRemoteChanged, savedPropertyIdsFromApi, savedPropertyIds;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getIsSavedPropertyIdsRemoteChanged)];
            case 1:
                isRemoteChanged = _a.sent();
                if (!isRemoteChanged) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.call(SavePropertiesApiSaga_1.getSavePropertyIdsApi)];
            case 2:
                savedPropertyIdsFromApi = _a.sent();
                return [4 /*yield*/, effects_1.put(SavePropertyRemoteAction_1.default.setSavePropertyIdsRemote(savedPropertyIdsFromApi))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SavePropertyRemoteAction_1.default.setIsSavePropertyIdsRemoteChanged(false))];
            case 4:
                _a.sent();
                return [2 /*return*/, savedPropertyIdsFromApi];
            case 5: return [4 /*yield*/, effects_1.select(getSavedPropertyIdsRemote)];
            case 6:
                savedPropertyIds = _a.sent();
                return [2 /*return*/, savedPropertyIds];
        }
    });
};
var getRecentlyViewedLocal = function (page) {
    var PAGE_SIZE, existingProperties, savedProperties;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (page < 1)
                    return [2 /*return*/, {
                            properties: [],
                            totalPages: 0,
                        }];
                PAGE_SIZE = 12;
                return [4 /*yield*/, effects_1.call(StorageApi_1.readRecentlyViewedLocalStorage)];
            case 1:
                existingProperties = _a.sent();
                savedProperties = existingProperties.slice((page - 1) * PAGE_SIZE, (page - 1) * PAGE_SIZE + PAGE_SIZE);
                return [2 /*return*/, {
                        properties: savedProperties,
                        totalPage: Math.ceil(existingProperties.length / PAGE_SIZE)
                    }];
        }
    });
};
var uploadLocalSavePropertyToRemote = function () {
    var savesFromLocal, localSaveSet;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(StorageApi_1.popSavedPropertyFromLocalStorage)];
            case 1:
                savesFromLocal = _a.sent();
                return [4 /*yield*/, effects_1.call(savedResultItemToSavePropertiesSaveSet, savesFromLocal)];
            case 2:
                localSaveSet = _a.sent();
                if (!(localSaveSet && localSaveSet.length)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(SavePropertiesApiSaga_1.addSavePropertiesApi, localSaveSet)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
};
var uploadLocalRecentlyViewedToRemote = function () {
    var savesFromLocal, localSaveSet;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(StorageApi_1.popRecentlyViewedFromLocalStorage)];
            case 1:
                savesFromLocal = _a.sent();
                return [4 /*yield*/, effects_1.call(savedResultItemToRecentlyViewSaveSet, savesFromLocal)];
            case 2:
                localSaveSet = _a.sent();
                if (!(localSaveSet && localSaveSet.length)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(SavePropertiesApiSaga_1.addRecentlyViewedApi, localSaveSet)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
};
var getSavedPropertiesRemote = function (page, pageSize) {
    var apiResult, savedResultItems, savePropertiesResult;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(SavePropertiesApiSaga_1.getSavePropertiesApi, page, pageSize)];
            case 1:
                apiResult = _a.sent();
                return [4 /*yield*/, effects_1.call(savedPropertyCompactsToSavedResultItems_1.savedPropertyCompactsToSavedResultItems, apiResult.properties)];
            case 2:
                savedResultItems = _a.sent();
                savePropertiesResult = {
                    properties: savedResultItems.map(function (it) { return (__assign(__assign({}, it), { isSaved: true })); }),
                    totalPage: apiResult.pager.totalPages
                };
                return [2 /*return*/, savePropertiesResult];
        }
    });
};
var getRecentlyViewedRemote = function (page) {
    var apiResult, savedResultItems, savePropertiesResult;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(SavePropertiesApiSaga_1.getRecentlyViewedApi, page)];
            case 1:
                apiResult = _a.sent();
                return [4 /*yield*/, effects_1.call(savedPropertyCompactsToSavedResultItems_1.savedPropertyCompactsToSavedResultItems, apiResult.properties)];
            case 2:
                savedResultItems = _a.sent();
                savePropertiesResult = {
                    properties: savedResultItems,
                    totalPage: apiResult.pager.totalPages
                };
                return [2 /*return*/, savePropertiesResult];
        }
    });
};
var addSavedPropertiesLocal = function (savedItems) {
    var ITEM_LIMIT, existingProperties, newSavedItems, finalSavedProperties;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                ITEM_LIMIT = 120;
                return [4 /*yield*/, effects_1.call(StorageApi_1.readSavedPropertyFromLocalStorage)];
            case 1:
                existingProperties = _a.sent();
                newSavedItems = savedItems.filter(function (it) { return existingProperties.findIndex(function (it2) { return it2.referenceId === it.referenceId; }) === -1; });
                existingProperties.unshift.apply(existingProperties, newSavedItems);
                finalSavedProperties = existingProperties.sort(sortByCreatedDate_1.sortByCreatedDate).slice(0, ITEM_LIMIT);
                return [4 /*yield*/, effects_1.call(StorageApi_1.setSavedPropertyToLocalStorage, finalSavedProperties)];
            case 2:
                _a.sent();
                return [2 /*return*/, true];
        }
    });
};
var addRecentlyViewedLocal = function (savedItems) {
    var ITEM_LIMIT, existingProperties, newSavedItems, finalSavedProperties;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                ITEM_LIMIT = 120;
                return [4 /*yield*/, effects_1.call(StorageApi_1.readRecentlyViewedLocalStorage)];
            case 1:
                existingProperties = _a.sent();
                newSavedItems = savedItems.filter(function (it) { return existingProperties.findIndex(function (it2) { return it2.referenceId === it.referenceId; }) === -1; });
                existingProperties.unshift.apply(existingProperties, newSavedItems);
                finalSavedProperties = existingProperties.sort(sortByCreatedDate_1.sortByCreatedDate).slice(0, ITEM_LIMIT);
                return [4 /*yield*/, effects_1.call(StorageApi_1.setRecentlyViewedToLocalStorage, finalSavedProperties)];
            case 2:
                _a.sent();
                return [2 /*return*/, true];
        }
    });
};
var addSavedPropertiesRemote = function (savedItems) {
    var saveSets, response, isSaved;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, effects_1.call(savedResultItemToSavePropertiesSaveSet, savedItems)];
            case 1:
                saveSets = _b.sent();
                return [4 /*yield*/, effects_1.call(SavePropertiesApiSaga_1.addSavePropertiesApi, saveSets)];
            case 2:
                response = _b.sent();
                isSaved = (_a = response.data) === null || _a === void 0 ? void 0 : _a.isSaved;
                if (!isSaved) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(SavePropertyRemoteAction_1.default.setIsSavePropertyIdsRemoteChanged(true))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4: return [2 /*return*/, isSaved];
        }
    });
};
var addRecentlyViewedRemote = function (savedItems) {
    var saveSets, response;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, effects_1.call(savedResultItemToRecentlyViewSaveSet, savedItems)];
            case 1:
                saveSets = _b.sent();
                return [4 /*yield*/, effects_1.call(SavePropertiesApiSaga_1.addRecentlyViewedApi, saveSets)];
            case 2:
                response = _b.sent();
                return [2 /*return*/, (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.isSaved];
        }
    });
};
var removeSavedPropertiesLocal = function (ids) {
    var existingProperties, newSavedProperties;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(StorageApi_1.readSavedPropertyFromLocalStorage)];
            case 1:
                existingProperties = _a.sent();
                newSavedProperties = existingProperties.filter(function (it) { return ids.indexOf(Number(it.referenceId)) < 0; });
                return [4 /*yield*/, effects_1.call(StorageApi_1.setSavedPropertyToLocalStorage, newSavedProperties)];
            case 2:
                _a.sent();
                return [2 /*return*/, true];
        }
    });
};
var removeSavedPropertiesRemote = function (ids) {
    var response, isDeleted;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, effects_1.call(SavePropertiesApiSaga_1.removeSavePropertyiesByPropertyIdsApi, ids)];
            case 1:
                response = _b.sent();
                isDeleted = (_a = response.data) === null || _a === void 0 ? void 0 : _a.isDeleted;
                if (!isDeleted) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.put(SavePropertyRemoteAction_1.default.setIsSavePropertyIdsRemoteChanged(true))];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3: return [2 /*return*/, isDeleted];
        }
    });
};
var updateAvailability = function (savedResultItems) {
    var detailResult, detailProperties, propertiesWithAvailability;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(SavePropertiesApiSaga_1.getPropertiesDetailByIdsApi, savedResultItems.map(function (it) { return Number(it.referenceId); }))];
            case 1:
                detailResult = _a.sent();
                detailProperties = detailResult.data.properties;
                propertiesWithAvailability = savedResultItems.map(function (it) { return (__assign(__assign({}, it), { available: detailProperties.find(function (it2) { return Number(it2.id) === Number(it.referenceId); }).isAvaliable })); });
                return [2 /*return*/, propertiesWithAvailability];
        }
    });
};
/// Public API
var getSavedProperties = function (page, pageSize) {
    var isGuest, result, propertiesWithAvailability, newProperties, savedProperties, propertiesWithAvailability, newProperties;
    if (pageSize === void 0) { pageSize = 12; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 1:
                isGuest = _a.sent();
                if (!isGuest) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(getSavedPropertiesLocal, page, pageSize)];
            case 2:
                result = _a.sent();
                return [4 /*yield*/, effects_1.call(updateAvailability, result.properties)];
            case 3:
                propertiesWithAvailability = _a.sent();
                newProperties = propertiesWithAvailability.sort(sortByCreatedDate_1.sortByCreatedDate).sort(sortByOnMarket_1.sortByOnMarket);
                return [2 /*return*/, __assign(__assign({}, result), { properties: newProperties })];
            case 4: return [4 /*yield*/, effects_1.call(uploadLocalSavePropertyToRemote)];
            case 5:
                _a.sent(); // pop all local to remote
                return [4 /*yield*/, effects_1.call(getSavedPropertiesRemote, page, pageSize)];
            case 6:
                savedProperties = _a.sent();
                return [4 /*yield*/, effects_1.call(updateAvailability, savedProperties.properties)];
            case 7:
                propertiesWithAvailability = _a.sent();
                newProperties = propertiesWithAvailability.sort(sortByCreatedDate_1.sortByCreatedDate).sort(sortByOnMarket_1.sortByOnMarket);
                return [2 /*return*/, __assign(__assign({}, savedProperties), { properties: newProperties })];
        }
    });
};
exports.getSavedProperties = getSavedProperties;
var getSavedPropertyIds = function () {
    var isGuest;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 1:
                isGuest = _a.sent();
                if (!isGuest) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.call(getSavedPropertyByIdsLocal)];
            case 2: return [2 /*return*/, _a.sent()];
            case 3: return [4 /*yield*/, effects_1.call(getSavedPropertyByIdsRemote)];
            case 4: return [2 /*return*/, _a.sent()];
        }
    });
};
exports.getSavedPropertyIds = getSavedPropertyIds;
var addSavedProperties = function (properties) {
    var savedItems, isGuest;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(resultItemToSavedResultItem, properties)];
            case 1:
                savedItems = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 2:
                isGuest = _a.sent();
                if (!isGuest) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(addSavedPropertiesLocal, savedItems)];
            case 3: return [2 /*return*/, _a.sent()];
            case 4: return [4 /*yield*/, effects_1.call(addSavedPropertiesRemote, savedItems)];
            case 5: return [2 /*return*/, _a.sent()];
        }
    });
};
exports.addSavedProperties = addSavedProperties;
var deleteSavedProperties = function (ids) {
    var isGuest;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 1:
                isGuest = _a.sent();
                if (!isGuest) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.call(removeSavedPropertiesLocal, ids)];
            case 2: return [2 /*return*/, _a.sent()];
            case 3: return [4 /*yield*/, effects_1.call(removeSavedPropertiesRemote, ids)];
            case 4: return [2 /*return*/, _a.sent()];
        }
    });
};
exports.deleteSavedProperties = deleteSavedProperties;
var getRecentlyViewed = function (page) {
    var savedPropertyIds, recentlyViewed, isGuest, newRecentlyViewed;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, effects_1.call(getSavedPropertyIds)];
            case 1:
                savedPropertyIds = _b.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 2:
                isGuest = _b.sent();
                if (!isGuest) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(getRecentlyViewedLocal, page)];
            case 3:
                recentlyViewed = _b.sent();
                return [3 /*break*/, 7];
            case 4: return [4 /*yield*/, effects_1.call(uploadLocalRecentlyViewedToRemote)];
            case 5:
                _b.sent(); // pop all local to remote
                return [4 /*yield*/, effects_1.call(getRecentlyViewedRemote, page)];
            case 6:
                recentlyViewed = _b.sent();
                _b.label = 7;
            case 7:
                newRecentlyViewed = __assign(__assign({}, recentlyViewed), { properties: ((_a = recentlyViewed.properties) === null || _a === void 0 ? void 0 : _a.map(function (it) { return savedPropertyIds.indexOf(Number(it.referenceId)) >= 0 ? (__assign(__assign({}, it), { isSaved: true })) : it; })) || [] });
                return [2 /*return*/, newRecentlyViewed];
        }
    });
};
exports.getRecentlyViewed = getRecentlyViewed;
var addRecentlyViewed = function (properties) {
    var savedItems, isGuest;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(resultItemToSavedResultItem, properties)];
            case 1:
                savedItems = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 2:
                isGuest = _a.sent();
                if (!isGuest) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(addRecentlyViewedLocal, savedItems)];
            case 3: return [2 /*return*/, _a.sent()];
            case 4: return [4 /*yield*/, effects_1.call(addRecentlyViewedRemote, savedItems)];
            case 5: return [2 /*return*/, _a.sent()];
        }
    });
};
exports.addRecentlyViewed = addRecentlyViewed;
